module.exports = __webpack_public_path__ + "img/page5.44a29c6e.png";